import React from 'react'
import { SeparatorItem } from './style'

/* TODO: Ask Nikolay how to make modification */
const Separator = () => {
	return <SeparatorItem />
}

export default Separator
